import { render, staticRenderFns } from "./FormGetBranch.vue?vue&type=template&id=33a8cd05&scoped=true&"
import script from "./FormGetBranch.vue?vue&type=script&lang=js&"
export * from "./FormGetBranch.vue?vue&type=script&lang=js&"
import style0 from "./FormGetBranch.vue?vue&type=style&index=0&id=33a8cd05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8cd05",
  null
  
)

export default component.exports